module.exports = __webpack_public_path__ + "static/media/14UNEP19.432ae48e.jpg";